import React from 'react';
import PropTypes from 'prop-types';
import { withMedia } from 'react-media-query-hoc';
import AllhomesListingWhatsNearbyWrapper from './allhomes-listing-whats-nearby-wrapper';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesListingWhatsNearby = props => {
  var mobile = props.media.mobile;
  var maxItems = mobile ? props.maxItemsMobile : props.maxItems;
  return ___EmotionJSX(AllhomesListingWhatsNearbyWrapper, {
    maxItems: maxItems,
    items: props.items,
    columns: props.columns
  });
};
AllhomesListingWhatsNearby.propTypes = {
  items: AllhomesListingWhatsNearbyWrapper.propTypes.items,
  maxItems: PropTypes.number,
  maxItemsMobile: PropTypes.number,
  media: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  columns: PropTypes.number
};
AllhomesListingWhatsNearby.defaultProps = {
  items: [],
  maxItems: 20,
  maxItemsMobile: 2,
  media: {},
  columns: 2
};
export default withMedia(AllhomesListingWhatsNearby);
export { AllhomesListingWhatsNearby as BaseAllhomesListingWhatsNearby };